import { Form, Formik } from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import FormFooter from '../../../../../components/form-footer';
import IntakeInsuranceInvestigationPersonalAutoUmbrellaDetailsFields from '../../../../../components/intake/insurance-investigation/personal/auto-umbrella/details-fields';
import InsuranceInvestigationPersonalAutoUmbrellaDetailsSchema from '../../../../../validation-schemas/insurance-investigation-personal-auto-umbrella-details-schema';
import { updateActiveFormInsuranceInvestigationPersonalAutoUmbrellaDetails, selectActiveFormInsuranceInvestigationPersonalAutoUmbrellaDetails } from '../../../../../reducers/active-form-slice';
import FormHeaderButtons from '../../../form-header-buttons';
import { hasNonBlankValues } from '../../../../../utility/has-values';


const IntakeInsuranceInvestigationPersonalAutoUmbrellaDetails = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();


    /**
     * get current form values
     */
    const insuranceInvestigationPersonalAutoUmbrella = useSelector(selectActiveFormInsuranceInvestigationPersonalAutoUmbrellaDetails);
    const hasValues = hasNonBlankValues(insuranceInvestigationPersonalAutoUmbrella);


    /**
     * handle the previous button
     */
    const handlePrevious = () => {
        navigate("/intake/");
    };


    /**
     * update active form & continue
     */
    const handleSubmit = (values) => {
        dispatch(updateActiveFormInsuranceInvestigationPersonalAutoUmbrellaDetails(values));
        navigate("/intake/insurance-investigation-personal-auto-umbrella/drivers-details");
    };

    /**
     * handle save for later
     */
    const handleSaveForLater = (values) => {
        dispatch(updateActiveFormInsuranceInvestigationPersonalAutoUmbrellaDetails(values));
    };


    /**
     * setup the initial values
     */
    const initialValues = {
        insuredType: '',
        dateOfLoss: '',
        insuredName: '',
        insuredAddress: '',
        insuredAddress2: '',
        insuredCity: '',
        insuredStateProvince: '',
        insuredZip: '',
        insuredCountry: '',
        insuredDob: '',
        insuredSsn: '',
        insuredVin: '',
        insuredLicensePlate: '',
        insuredLicenseNumber: '',
        ownersName: '',
        ownersAddress: '',
        ownersAddress2: '',
        ownersCity: '',
        ownersStateProvince: '',
        ownersZip: '',
        ownersCountry: '',
        ownersDob: '',
        ownersLicenseNumber: '',
        ownerIsDriver: '',
        locateAddress: '',
        locateAddress2: '',
        locateCity: '',
        locateStateProvince: '',
        locateZip: '',
        locateCountry: ''
    };


    return (
        <div className="page intake">
            <Formik
                initialValues={hasValues ? insuranceInvestigationPersonalAutoUmbrella : initialValues}
                validationSchema={InsuranceInvestigationPersonalAutoUmbrellaDetailsSchema.fields.insuranceInvestigationPersonalAutoUmbrellaDetails}
                onSubmit={handleSubmit}
            >
                {({ errors, dirty, isValid, touched, values }) => (
                    <Form>
                        <div className="form-header-buttons">
                            <div>
                                <h2>Insured's Details</h2>
                                <p>FILL WITH “N/A” IF NOT APPLICABLE ON REQUIRED FIELDS</p>
                            </div>
                            <FormHeaderButtons updateForm={() => handleSaveForLater(values)}/>
                        </div>
                
                        <IntakeInsuranceInvestigationPersonalAutoUmbrellaDetailsFields
                            errors={errors}
                            touched={touched}
                            values={values}
                        />

                        <FormFooter
                            handlePrevious={handlePrevious}
                            showPrevious={true}
                            disableNext={!((dirty || hasValues) && isValid)}
                            showNext={true}
                            progress={`25`}
                        />
                    </Form>
                )}
            </Formik>
        </div>
    );
};

export default IntakeInsuranceInvestigationPersonalAutoUmbrellaDetails;